import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "3.5 2 6.5 12.5 18 12.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "15", x2: "18.5", y1: "12.5", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2.75 18a13 13 0 0 0 18.5 0", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RockingChair";
const RockingChair = memo(themed(Icon));
export {
  RockingChair
};
//# sourceMappingURL=rocking-chair.js.map
